var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeCommunity({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 25,
    viewBox: "0 0 28.026 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15540",
    "data-name": "Path 15540",
    d: "M200.559,140.09a7.254,7.254,0,0,0-5.253,2.251,7.869,7.869,0,0,0,0,10.835l11.116,11.6h0a1,1,0,0,0,1.454,0q5.565-5.8,11.132-11.6a7.846,7.846,0,0,0,0-10.819,7.269,7.269,0,0,0-10.521,0l-1.329,1.376-1.329-1.391a7.288,7.288,0,0,0-5.269-2.251Zm0,1.954a5.274,5.274,0,0,1,3.815,1.673l2.064,2.157a1,1,0,0,0,1.454,0l2.048-2.142a5.17,5.17,0,0,1,7.614,0,5.87,5.87,0,0,1,0,8.067q-5.2,5.417-10.4,10.834l-10.4-10.85a5.871,5.871,0,0,1,0-8.067,5.242,5.242,0,0,1,3.8-1.673Z",
    transform: "translate(-193.145 -140.09)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeCommunity);
export default __webpack_public_path__ + "static/media/LikeCommunity.9c5aa375bff4a291f0e024121783fb5a.svg";
export { ForwardRef as ReactComponent };